// src/presentation/pages/ClinicalExamination/sections/MotorSymptomsSection.tsx
import React from "react";
import { CardTitle } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";
import { booleanRadioValue } from "../types";

interface MotorSymptomsSectionProps {
  slownessOrStiffness: boolean | null;
  slowMovementOrBalanceIssues: boolean | null;
  onSlownessOrStiffnessChange: (value: boolean) => void;
  onSlowMovementOrBalanceIssuesChange: (value: boolean) => void;
}

export const MotorSymptomsSection: React.FC<MotorSymptomsSectionProps> = ({
  slownessOrStiffness,
  slowMovementOrBalanceIssues,
  onSlownessOrStiffnessChange,
  onSlowMovementOrBalanceIssuesChange,
}) => {
  const { t } = useTranslation("patients");
  return (
    <div className=" border-gray-200">
      <div className="pb-3">
        <CardTitle className="text-base font-semibold text-gray-900">
          {t("clinicalSections.motorSymptoms.title")}
        </CardTitle>
      </div>
      <div className="space-y-6">
        {/* Slowness or Stiffness */}
        <div>
          <p className="text-sm text-gray-700 mb-3">
            {t("clinicalSections.motorSymptoms.stiffnessQuestion")}
          </p>
          <RadioGroup
            value={booleanRadioValue(slownessOrStiffness)}
            onValueChange={(val) => onSlownessOrStiffnessChange(val === "true")}
            className="flex gap-6"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="true" id="stiffness-yes" />
              <Label
                htmlFor="stiffness-yes"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.yes")}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="false" id="stiffness-no" />
              <Label
                htmlFor="stiffness-no"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.no")}
              </Label>
            </div>
          </RadioGroup>
        </div>

        {/* Slow Movement or Balance Issues */}
        <div>
          <p className="text-sm text-gray-700 mb-3">
            {t("clinicalSections.motorSymptoms.balanceQuestion")}
          </p>
          <RadioGroup
            value={booleanRadioValue(slowMovementOrBalanceIssues)}
            onValueChange={(val) =>
              onSlowMovementOrBalanceIssuesChange(val === "true")
            }
            className="flex gap-6"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="true" id="balance-yes" />
              <Label
                htmlFor="balance-yes"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.yes")}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="false" id="balance-no" />
              <Label
                htmlFor="balance-no"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.no")}
              </Label>
            </div>
          </RadioGroup>
        </div>
      </div>
    </div>
  );
};
